FeedsApp.Models.CustomTemplate = FeedsApp.Models.FeedsBase.extend({
	url: function() {
		return "" + FeedsApp.Variables.CustomTemplateId;
	}
});